// extracted by mini-css-extract-plugin
export default {"actions":"ActionEmployees_actions__BVNnq","actionButton":"ActionEmployees_actionButton__0waoK"};